<template>
  <b-modal
    v-model="isOpen"
    scrollable
    centered
    size="s"
    :title="'Редактирование документа'"
    @hidden="onClose"
    @ok="onClose"
  >
    <loading v-if="isLoading">
      Загрузка данных
    </loading>
    <div v-else>
      <b-row>
        <b-col>
          <b-form-file
            v-model="updateFile"
            class="mt-3"
            plain
            @input="sendFile(updateFile)"
          />
        </b-col>
      </b-row>
    </div>
    <template #modal-footer>
      <div>
        <transition name="slide-fade">
          <b-button
            v-if="updateFile"
            variant="primary"
            @click="onClickUpdate"
          >
            Обновить
          </b-button>
        </transition>
        <b-button
          variant="danger"
          class="ml-2"
          @click="onClose"
        >
          Отмена
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import Loading from '@/components/Loading';
import { formatISO } from 'date-fns';
import { api } from '@/helpers/api';
import { getFileExtension } from '@/helpers/utils';

export default {
  name: 'EditClinicDocument',
  components: {
    Loading,
  },
  props: {
    modalName: {
      type: [String, Number],
      default: null,
    },
    currentDocumentInfo: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isOpen: true,
      isLoading: false,
      updateFile: null,
      newDocument: null,
      document: {},
      fileApi: 'File/clinicdocument/upload',
    };
  },
  async created() {
    this.isLoading = true;
    this.newDocument = { ...this.currentDocumentInfo };
    this.isLoading = false;
  },
  methods: {
    async onClose() {
      await this.deleteDocument();

      this.$store.commit(this.$types.CLOSE_MODAL, { modalName: this.modalName });
    },
    async deleteDocument() {
      if (this.document.id) {
        this.$store.dispatch(this.$types.CLINIC_DOCUMENTS_DELETE, {
          document: this.document,
          isFetch: false,
        });
      }
    },
    async onClickUpdate() {
      await this.$store.dispatch(this.$types.CLINIC_DOCUMENTS_UPDATE, this.newDocument);
      const clinicData = await this.$store.dispatch(this.$types.CLINIC_FETCH, this.newDocument.clinicId);
      this.$store.commit(this.$types.CLINIC_SET, {
        ...clinicData,
        info: clinicData,
      });
      await this.onClose();
    },
    async sendFile(fileObject) {
      const extension = getFileExtension(fileObject.name);

      if (this.document.id) {
        await this.deleteDocument();
      }

      try {
        const fd = new FormData();

        if (this.fileApi) {
          fd.append('file', fileObject);
        }

        const { data: { guid } } = await api.post(this.fileApi || `File/${extension}`, this.fileApi ? fd : fileObject, {
          headers: {
            'Content-Type': fileObject.type,
          },
        });

        this.newDocument.fileId = guid;
        this.newDocument.timeCreated = formatISO(new Date());
        this.newDocument.title = fileObject.name;
        delete this.newDocument.fileUrl;
        delete this.newDocument.fileThumbnailUrl;
        this.document.id = guid;
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style lang="scss">
</style>
